import { render, staticRenderFns } from "./NotRatedOptionReasonDialog.vue?vue&type=template&id=12cef5d1"
import script from "./NotRatedOptionReasonDialog.vue?vue&type=script&lang=ts"
export * from "./NotRatedOptionReasonDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports